jQuery(function($) {
	// Special easing function that covers half of the remaining distance for
	// each 10% of progress, like in Zeno's paradox. Because we stop at 100%, it
	// never actually reaches full completion. Used because we don't actually
	// know the progress of AJAX requests and just want to display something that
	// goes fast in the beginning but doesn't complete until the response
	// actually comes back. Should be used with a duration of 10 times the
	// expected loading time.
	$.extend($.easing, {
		zeno: function(x) {
			return 1.0 - Math.pow(0.5, x / 0.1);
		},
	});

	// TODO: identify these elements by classes instead, and link them together using data attributes
	var recipeSearchForm = $('#recipe-search-form');
	var recipeResults = $('#recipe-results');
	if (recipeSearchForm.length && recipeResults.length) {
		initRecipeSearch($, recipeSearchForm, recipeResults);
	}
});

function initRecipeSearch($, recipeSearchForm, recipeResults) {
	var moreRow = $('.recipe-search-row-more');
	var moreToggle = $('.recipe-search-more-toggle');
	var progress = recipeSearchForm.find('.progress');
	var progressBar = recipeSearchForm.find('.progress-bar');
	var recipeResultsAnchor = $('#recipe-results-anchor');

	function setProgress(progress) {
		// Using transform rather than width because it's faster, resulting in a
		// smoother animation (compositor-only property).
		progressBar.css({'transform': 'scaleX(' + progress + ')'});
	}

	function loadRecipeResults(queryString, updateUrl) {
		recipeResults.addClass('loading');
		setProgress(0.0);
		progressBar.show();
		var halfwayDuration = 150;
		var doneDuration = 150;
		var fadeDuration = 150;
		var startTime = null;
		var doneTime = null;
		var done = false;
		var progress = 0.0;
		var doneProgress = null;
		var updateProgress = function(now) {
			if (startTime === null) {
				startTime = now;
			}
			if (!done) {
				// We don't know actual progress of AJAX requests. Instead, we just make
				// a bar that reaches the halfway point at a typical duration, and fills
				// up exponentially slower, never quite reaching the end.
				var elapsed = now - startTime;
				progress = 1.0 - Math.pow(0.5, elapsed / halfwayDuration);
				setProgress(progress);
			} else {
				// We're done, but the progress bar has not filled up yet. Rush it to
				// completion linearly in a fixed amount of time.
				if (doneTime === null) {
					doneTime = now;
					doneProgress = progress;
				}
				var doneElapsed = now - doneTime;
				if (doneElapsed >= doneDuration) {
					setProgress(1.0);
					progressBar.fadeOut(fadeDuration);
					return;
				}
				setProgress(doneProgress + (1.0 - doneProgress) * (doneElapsed / doneDuration));
			}
			window.requestAnimationFrame(updateProgress);
		};
		window.requestAnimationFrame(updateProgress);
		$.get({
			url: "../getrecipes/?" + queryString,
			dataType: 'html',
		}).done(function(msg) {
			recipeResults.html(msg);
		}).fail(function(jqXHR, textStatus, errorThrown) {
			console.error(errorThrown);
			recipeResults.html('<p class="no-recipes">Er ging iets mis bij het laden van de recepten: ' + textStatus + '</p>');
		}).always(function() {
			recipeResults.removeClass('loading');
			done = true;
		});

		if (updateUrl) {
			window.history.pushState(null, document.title, window.location.href.split('?')[0] + '?' + queryString);
		}
	}

	function serializeForm() {
		var nonEmptyFields = recipeSearchForm.find(':input').filter(function() { return !!$(this).val(); });
		return nonEmptyFields.serialize();
	}

	if (window.history && window.history.pushState) {
		$(document).on('click', '.recipe-pagination a.page-numbers', function(event) {
			var queryString = this.search.substr(1);
			loadRecipeResults(queryString, true);
			if ($(this).parents('.recipe-pagination').hasClass('scroll-to-top')) {
				$('html, body').animate({
					scrollTop: recipeResultsAnchor.offset().top
				}, 300);
			}
			event.preventDefault();
		});

		recipeSearchForm.on('submit', function(event) {
			loadRecipeResults(serializeForm(), true);
			$(':focus').blur(); // Allow arrow key navigation after Enter.
			event.preventDefault();
		});

		window.addEventListener('popstate', function(event) {
			loadRecipeResults(window.location.search.substring(1), false);
		});
	}

	$.widget('custom.taxonomyselectmenu', $.ui.selectmenu, {
		_renderButtonItem: function(item) {
			var buttonText = $(item.element).attr('data-button-text');
			return $('<span>')
				.addClass('ui-selectmenu-text')
				.toggleClass('empty', !item.value)
				.text(buttonText)
				.attr('title', item.label);
		},
	});

	recipeSearchForm.find('.selectmenu').taxonomyselectmenu({
		change: function(event, ui) {
			updateMoreToggle();
			loadRecipeResults(serializeForm(), true);
		},
	});
	recipeSearchForm.find('.checkboxradio').on('change', function() {
		updateMoreToggle();
		loadRecipeResults(serializeForm(), true);
	});

	function isMoreVisible() {
		return moreRow.is(':visible');
	}

	function setMoreVisible(visible, effect) {
		if (visible) {
			moreRow.show(effect);
		} else {
			moreRow.hide(effect);
		}
		moreToggle.find('.ui-selectmenu-icon').toggleClass('ui-selectmenu-icon-up', visible);
	}

	function hasInputInMore() {
		var nonEmptyFields = moreRow.find(':input').filter(function() { return !!$(this).val(); });
		return !!nonEmptyFields.serialize();
	}

	function updateMoreToggle() {
		moreToggle.find('.ui-selectmenu-text').toggleClass('empty', !hasInputInMore());
	}

	moreToggle.on('click', function(event) {
		setMoreVisible(!isMoreVisible(), 'blind');
	});

	setMoreVisible(hasInputInMore());
	updateMoreToggle();
}
